export enum AlertLevels {
  Red = "Red",
  Orange = "Orange",
  Yellow = "Yellow",
}
